<div class="pd-24 component-container">
  <div class="fg-1">
    <div class="card inverse-bg-transparent">
      <p-tabs [value]="0" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab [value]="0">{{ 'REQUIREMENT_SUBMISSIONS.ACTIVE' | translate }}</p-tab>
          <p-tab [value]="1">{{ 'REQUIREMENT_SUBMISSIONS.ARCHIVE' | translate }}</p-tab>
        </p-tablist>
        <p-tabpanels>
          <!-- Active Submissions Tab -->
          <p-tabpanel [value]="0">
            @if (loaded) {
              <p-table class="table-requirements" [value]="activeSubmissions" styleClass="p-datatable-striped" [scrollable]="true" scrollHeight="calc(100vh - 350px)">
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="id">
                      {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.ID' | translate }}
                      <p-sortIcon field="id"></p-sortIcon>
                    </th>
                    <th pSortableColumn="full_name">
                      {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.FULL_NAME' | translate }}
                      <p-sortIcon field="full_name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="title">
                      {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.TITLE' | translate }}
                      <p-sortIcon field="title"></p-sortIcon>
                    </th>
                    <th pSortableColumn="created_at">
                      {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATED_AT' | translate }}
                      <p-sortIcon field="created_at"></p-sortIcon>
                    </th>
                    <th style="width: 100px"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-requirementSubmission>
                  <tr class="fz-14">
                    <td>{{ requirementSubmission.id }}</td>
                    <td>{{ requirementSubmission.full_name }}</td>
                    <td>
                      @for (req of requirementSubmission.requirements; track req; let last = $last) {
                        <span> {{ req.title }}{{ !last ? ' | ' : '' }} </span>
                      }
                    </td>
                    <td>{{ requirementSubmission.created_at | date : 'dd/MM/yyyy, HH:mm' }}</td>
                    <td>
                      <button
                        *hasPermission="permissions.requirement_submissions.groups.general.components.approve_reject_submission"
                        type="button"
                        (click)="edit($event, requirementSubmission)"
                        class="btn btn-icon primary transparent"
                        >
                        <i aria-hidden="true" class="icon icon-pencil"></i>
                        <span class="sr-only">{{ 'COMMON.BUTTONS.EDIT' | translate }}</span>
                      </button>
                      <button
                        *hasPermission="permissions.requirement_submissions.groups.general.components.view_submission"
                        type="button"
                        (click)="viewDetails($event, requirementSubmission)"
                        class="btn btn-icon primary transparent"
                        >
                        <i aria-hidden="true" class="pi pi-eye"></i>
                        <span class="sr-only">{{ 'COMMON.BUTTONS.VIEW' | translate }}</span>
                      </button>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5">
                      <p-message severity="info" class="w-stretch">
                        {{ NO_RESULTS_MESSAGE }}
                      </p-message>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            }

            <!-- Pagination for Active Submissions -->
            @if (loaded && activeTotalRecords > 0) {
              <div class="pagination-container mt-16" [ngClass]="{ 'rtl-pagination': isRTL }">
                <p-paginator
                  [rows]="activeItemsPerPage"
                  [totalRecords]="activeTotalRecords"
                  [first]="(activeCurrentPage - 1) * activeItemsPerPage"
                  (onPageChange)="onActivePageChange($event)"
                  [showCurrentPageReport]="true"
                  [currentPageReportTemplate]="paginationTemplate"
                  [showFirstLastIcon]="true"
                  [showPageLinks]="true"
                  styleClass="p-paginator-bottom"
                  >
                </p-paginator>
              </div>
            }
          </p-tabpanel>

          <!-- Archived Submissions Tab -->
          <p-tabpanel [value]="1">
            <!-- Filter Panel -->
            <div class="filter-panel mb-3">
              <div style="display: flex; gap: 12px; align-items: center; flex-wrap: wrap">
                <div style="flex: 0 0 250px; min-width: 200px">
                  <span class="p-input-icon-left" style="width: 100%">
                    <i class="pi pi-search"></i>
                    <input
                      id="phoneNumber"
                      type="text"
                      pInputText
                      [(ngModel)]="filters.phoneNumber"
                      style="width: 100%"
                      [placeholder]="'REQUIREMENT_SUBMISSIONS.FILTERS.PHONE_NUMBER' | translate"
                      />
                    </span>
                  </div>

                  <div style="flex: 0 0 280px; min-width: 200px">
                    <p-datepicker
                      id="dateRange"
                      [(ngModel)]="dateRange"
                      selectionMode="range"
                      [showIcon]="true"
                      dateFormat="dd/mm/yy"
                      [readonlyInput]="true"
                      styleClass="w-100"
                      (onSelect)="onDateRangeSelect($event)"
                      (onClear)="onDateRangeClear()"
                      [placeholder]="'REQUIREMENT_SUBMISSIONS.FILTERS.DATE_RANGE' | translate"
                      >
                    </p-datepicker>
                  </div>

                  <div style="flex: 0 0 auto; display: flex; gap: 8px">
                    <button pButton type="button" label="{{ 'COMMON.BUTTONS.FILTER' | translate }}" class="p-button-primary" (click)="applyFilters()"></button>
                    <button pButton type="button" label="{{ 'COMMON.BUTTONS.RESET' | translate }}" class="p-button-outlined p-button-secondary" (click)="resetFilters()"></button>
                  </div>
                </div>
              </div>

              @if (loaded) {
                <p-table
                  class="table-requirements"
                  [value]="flattenedArchivedRequirements"
                  styleClass="p-datatable-striped"
                  [scrollable]="true"
                  scrollHeight="calc(100vh - 450px)"
                  (onSort)="onSort($event)"
                  [sortField]="sortField"
                  [sortOrder]="sortOrder"
                  >
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 60px; text-align: center">#</th>
                      <th pSortableColumn="title">
                        {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.TITLE' | translate }}
                        <p-sortIcon field="title"></p-sortIcon>
                      </th>
                      <th pSortableColumn="submission_id">
                        {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.ID' | translate }}
                        <p-sortIcon field="submission_id"></p-sortIcon>
                      </th>
                      <th pSortableColumn="type">
                        {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.TYPE' | translate }}
                        <p-sortIcon field="type"></p-sortIcon>
                      </th>
                      <th pSortableColumn="pass_first_name">
                        {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.FULL_NAME' | translate }}
                        <p-sortIcon field="pass_first_name"></p-sortIcon>
                      </th>
                      <th pSortableColumn="created_at">
                        {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.CREATED_AT' | translate }}
                        <p-sortIcon field="created_at"></p-sortIcon>
                      </th>
                      <th pSortableColumn="user_full_name">
                        {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.USER_FULL_NAME' | translate }}
                        <p-sortIcon field="user_full_name"></p-sortIcon>
                      </th>
                      <th pSortableColumn="approved_at">
                        {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.APPROVED_AT' | translate }}
                        <p-sortIcon field="approved_at"></p-sortIcon>
                      </th>
                      <th pSortableColumn="reviewed_expiration_date">
                        {{ 'REQUIREMENT_SUBMISSIONS.FIELDS.EXPIRATION_DATE' | translate }}
                        <p-sortIcon field="reviewed_expiration_date"></p-sortIcon>
                      </th>
                      <th style="width: 100px"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-req let-i="rowIndex">
                    <tr class="fz-14">
                      <td style="text-align: center">{{ (archivedCurrentPage - 1) * archivedItemsPerPage + i + 1 }}</td>
                      <td>{{ req.title }}</td>
                      <td>{{ req.submission_id }}</td>
                      <td>{{ 'GENERAL.' + req.type | translate }}</td>
                      <td>{{ req.pass_first_name }} {{ req.pass_last_name }}</td>
                      <td>{{ req.created_at | date : 'dd/MM/yyyy, HH:mm' }}</td>
                      <td>{{ req.user_full_name }}</td>
                      <td>{{ req.approved_at || req.expiration_date | date : 'dd/MM/yyyy, HH:mm' }}</td>
                      <td>{{ req.reviewed_expiration_date || req.expiration_date | date : 'dd/MM/yyyy' }}</td>
                      <td>
                        <button type="button" (click)="viewRequirement($event, req)" class="btn btn-icon primary transparent">
                          <i aria-hidden="true" class="pi pi-eye"></i>
                          <span class="sr-only">{{ 'REQUIREMENT_SUBMISSIONS.FIELDS.VIEW' | translate }}</span>
                        </button>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="10">
                        <p-message severity="info" class="w-stretch">
                          {{ NO_RESULTS_MESSAGE }}
                        </p-message>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              }

              <!-- Pagination for Archived Submissions -->
              @if (loaded && archivedTotalRecords > 0) {
                <div class="pagination-container mt-16" [ngClass]="{ 'rtl-pagination': isRTL }">
                  <p-paginator
                    [rows]="archivedItemsPerPage"
                    [totalRecords]="archivedTotalRecords"
                    [first]="(archivedCurrentPage - 1) * archivedItemsPerPage"
                    (onPageChange)="onArchivedPageChange($event)"
                    [showCurrentPageReport]="true"
                    [currentPageReportTemplate]="paginationTemplate"
                    [showFirstLastIcon]="true"
                    [showPageLinks]="true"
                    styleClass="p-paginator-bottom"
                    >
                  </p-paginator>
                </div>
              }
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>

        @if (!loaded) {
          <div>
            <div class="centerbox">
              <p-progressSpinner strokeWidth="4" [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
            </div>
          </div>
        }

        <app-modal-requirement-submission-form [(model)]="model" #modalForm (onChange)="onSubmissionChange($event)"></app-modal-requirement-submission-form>
      </div>
    </div>
  </div>
